export default __webpack_public_path__ + "static/media/filter_mobility_icon.897f8c6e.svg";